import { image } from "../../Assets";
   
const TeamData = [
    {
        id:1,
        img:image.sliderteam1,
        name: "Saurabh Gangwar",
        title: "Managing Director",
        linkedinurl:"https://www.linkedin.com/in/saurabh-gangwar/",
        about:"Accomplished, results-driven Executive Leader with more than 15 years of AEC industry experience, Saurabh is a diversely talented Technologist and Design; Construction Expert with cross- industry contributions and accomplishments encompassing Architectural Design, Construction Management, Technology Management, IT infrastructures, Building Information Modeling (BIM) implementation, Sustainable Practices and LEED compliance. Complementing his architectural and construction industry background with an MBA degree, Saurabh is a proven strategist with a reputation for defining enterprise technology strategies and solutions which reduce costs, improve efficiencies, and support the attainment of organizational goals. Articulate communicator, skilled in establishing and cultivating powerful relationships with executives and staff, project teams, vendors, and customers to ensure the successful integration of technology solutions. Experienced in successfully negotiating and managing various vendor contracts and agreements."
    },
    {
        id:2,
        img:image.sliderteam2,
        name: "Zubair Siddiqui",
        title: "Principal",
        linkedinurl:"https://www.linkedin.com/in/zubair-siddiqui-ab9b6aa/",
        about:"With more than 15 years of industry experience, Zubair is a seasoned professional with expertise in digital transformation of processes, innovative project management techniques and data-driven requirements analysis. His invaluable owner organizations’ experience involved developing roadmap strategies for developing state-of-the-art technologies to improve the design and construction process and delivery of outcome-based solutions. With an impressive portfolio of managing international projects in accordance with technology-led industry best practices, Zubair lends a holistic approach to digital project management by providing customized and collaborative solutions to the End User. Zubair is PMP certified and holds a master’s degree in construction management, in addition to having an architectural degree and a wealth of BIM/VDC experience, bringing key and focused expertise in Digital Project Delivery Industry."
    },        
    // {
    //     id:3,
    //     img:image.teammember6,
    //     name: "Chase Bozel",
    //     title: "Advisor ",        
    //     about: 
    //         <>
    //             <p>Chase is responsible for business management and strategy for Fractile, as well as
    //             development and deployment of the Building Solutions Programs. He drives operational
    //             efficiencies through innovation, collaboration, and implementing best practices.</p>
    //             <p>
    //             With 8 years of experience in variety of leadership roles, Chase has a strong basis for
    //             understanding different business models and developing new businesses. During his
    //             time managing the financial planning and analysis (FP&amp;A) team at Clark Construction
    //             Group, Chase has developed expertise in finance, business development and planning,
    //             and growth strategies. While leading the national equipment group for Clark, Chase led
    //             the effort to increase visibility, streamline processes, develop KPIs and procurement
    //             standards across six equipment yards and 7 companies.
    //             </p>
    //             <p>Chase holds a BA in Economics from the University of Maryland College Park and is an
    //             active member of the National Multiple Sclerosis Society and G.B. Charities, which
    //             sponsors children and adolescents from hard-working, low-income families living in at-
    //             risk areas.</p>
    //         </>
    // },   
    {
        id:4,
        img:image.sliderteam9,
        name: "Shoaib Ahmed",
        title: "BIM Manager",    
        linkedinurl:"https://www.linkedin.com/in/sshoaiba",    
        about:
            <>
                <p>Shoaib has over seven years of experience in the construction industry and brings a
                project management lens to digital coordination and technical problem-solving. He has
                led MEPF scopes on some of the most significant federal projects, including the Cannon
                House Office Building Renewal on Capitol Hill and the Wargaming and Analysis Center
                at Marine Corps Base Quantico.</p>
                <p>At Fractile, Shoaib serves as the BIM lead, contributing to high-impact projects ranging
                from data center campuses and hospitals to transit infrastructure and mixed-use
                developments. His work is grounded in a deep understanding of field execution,
                enabling him to bridge the gap between models and real-world constructability.</p>
                <p>He is passionate about leveraging automation in BIM to streamline coordination,
                reduce manual effort, and improve delivery outcomes across all phases of construction.
                Shoaib holds a Bachelor’s in Civil Engineering and a Master’s degree in Civil
                Engineering with a specialization in Construction Management from Georgia Tech.</p>        
            </>
    },  
    {        
        id:5,
        img:image.sliderteam5,
        name: "Shalini Priyadarshini",
        title: "Studio Lead",
        linkedinurl:"https://www.linkedin.com/in/shalini-priyadarshini-9b211b1b1/",
        about:
            <>  <p>With over two decades of academic and industry experience in architecture and
                construction across the US and India, she&#39;s a perfect fit. Her background in technology,
                entrepreneurship, and building operations from her time at Clark Construction Group
                enhances our momentum. Shalini is a strong advocate for data-driven decision-making
                in the building industry. She&#39;s passionate about jobsite safety and is developing a digital
                tool to mitigate worker injuries and deaths as part of her PhD research. She holds a
                Bachelor&#39;s in Architecture, a Master&#39;s in Construction Management, and a Certificate in
                Technology Entrepreneurship.</p>
            </>
    },
    // {       
       
    //     id:4,
    //     img:image.teammember4,
    //     name: "Chirs Baker",
    //     title: "Advisor",
    //     about:"Chris has over 15 years of experience in strategic and general management roles supporting companies across a variety of industries, including real estate and manufacturing.  He is passionate about supporting the development of new solutions for pressing challenges facing industries and companies. Chris holds degrees in Accounting and Finance from the University of Wisconsin-Milwaukee."
    // },    
    // {
    //     id:5,
    //     img:image.teammember3,
    //     name: "Brian Krause",
    //     title: "Advisor",
    //     about:<>
    //     <p>
    //         Brian has over 20 years of international construction experience working for the largest builders in the United States. Brian has a passion for construction data and technology and has led all levels of VDC/BIM, reality capture, and construction technology implementation, development, and support. 
    //     </p>
    //     <p>In 2019 Brian founded Coda, LLC, a construction technology firm focused on mitigating owner’s risks. Brian holds a Bachelor of Architecture degree from Virginia Tech. He was a member of the first graduating class of the Virtual Design & Construction (VDC) Certificate Program at Stanford CIFE (Center for Integrated Facility Engineering). Brian has presented on and led AEC technology discussions at events throughout the United States and worldwide sharing his passion for solving real estate, design, and construction challenges by leveraging technology and data.</p>
        
    //     </>
    // }, 
         
    {
        id:6,
        img:image.sliderteam7,
        name: "Sahil Gupta",
        title: "Senior Analyst",    
        linkedinurl:"https://www.linkedin.com/in/sahilgupta993/",    
        about: 
            <>
                <p>Sahil brings over 7 years of industry experience in construction, encompassing both
                design and field operations. He holds a Bachelor&#39;s degree in Mechanical Engineering
                and a Master&#39;s in Business Analytics from the University of Maryland&#39;s Robert H. Smith
                School of Business. His combination of hands-on expertise and strategic business
                insights makes him a perfect fit for our team.</p>
                <p>
                Sahil is a staunch proponent of technology and has played a focal role in several cloud
                computing initiatives aimed at streamlining project deliverables. His impressive portfolio
                includes involvement in prestigious projects such as Underground Metro Stations,
                Terminal Buildings, and the new Indian Parliament House, where he served as a MEP
                manager.
                </p>
            </>
    },         
    {
        id:7,
        img:image.teammember8,
        name: "Robby Parker",
        title: "Business Analyst",
        linkedinurl:"https://www.linkedin.com/in/robby-parker-99968b1b7/",       

        about: 
            <>
                <p>Robby has over a year of experience at Clark, where he worked on the Data Analytics
                and Center of Excellence teams, and now brings his expertise to Fractile. At Fractile, he
                oversees end-to-end billing processes, managing both supplier invoices and client
                billings while optimizing schedules to ensure timely invoicing and payments. He
                collaborates closely with project teams to align billing with key milestones and
                deliverables, continuously refining workflows for greater efficiency and accuracy. Robby
                also manages the full lifecycle of projects in Kantata—from setup through
                completion—tracking revenue and cost milestones, overseeing billing and invoicing,
                coordinating team activities, and monitoring project hours to ensure efficient resource
                allocation. He provides monthly reports on actual and forecasted financials, supporting
                transparency and strategic decision-making.</p>
                <p>
                Robby holds a bachelor’s degree in Economics and an M.S. in Commerce from the
                University of Virginia. His background in data analytics and economics, paired with his
                experience in developing business process improvements and driving analytics
                solutions, makes him a perfect fit for our team.
                </p>
            </>
    },   
    {
        id:8,
        img:image.teammember10,
        name: "Maithili Deshmukh",
        title: "Senior BIM Coordinator",            
        linkedinurl:"https://www.linkedin.com/in/maithili-des/",   
        about:
            <>
            <p>Maithili is a proficient candidate with over 7 years of industrial experience in Building Information Modeling (BIM) and Virtual Design & 
            Construction (VDC) along with comprehensive understanding of engineering management principles. She holds a Bachelor's degree in Civil Engineering 
            and a Master's degree in Infrastructure Management and Engineering Management. Her extensive experience contains contributions to multi-million 
            dollar projects like Residential and Office structure, Mixed- use and Data centers. </p>
            <p>
            Maithili’s expertise includes implementation of BIM practices, development of BIM Execution Plans and Revit Contents and leading coordination to 
            enhance project efficiency and optimize construction timeline by reducing errors. Her analytical skills extend to monitoring VDC metrics and 
            utilizing data for process improvement and operational oprtimization makes her an ideal candidate for our team.</p>
            </>
    }
]

export default TeamData;